import { render } from "./ClaimCard.vue?vue&type=template&id=946e6f6e&scoped=true&ts=true"
import script from "./ClaimCard.vue?vue&type=script&lang=ts"
export * from "./ClaimCard.vue?vue&type=script&lang=ts"

import "./ClaimCard.vue?vue&type=style&index=0&id=946e6f6e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946e6f6e"]])

export default __exports__